declare global {
  interface Document {
    fullscreenElement?: HTMLElement;

    webkitFullscreenElement?: HTMLElement;
    webkitCurrentFullScreenElement?: HTMLElement;
    mozFullScreenElement?: HTMLElement;
    msFullscreenElement?: HTMLElement;

    webkitExitFullscreen?: () => Promise<void>;
    webkitCancelFullScreen?: () => Promise<void>;
    mozCancelFullScreen?: () => Promise<void>;
    msExitFullscreen?: () => Promise<void>;

    onwebkitfullscreenchange?: () => void;
    onmozfullscreenchange?: () => void;
    onmsfullscreenchange?: () => void;
  }

  interface HTMLElement {
    webkitRequestFullScreen?: () => Promise<void>;
    mozRequestFullScreen?: () => Promise<void>;
    msRequestFullscreen?: () => Promise<void>;
  }
}

export function isFullscreen(): boolean {
  return document.fullscreenElement != null
    || document.webkitFullscreenElement != null
    || document.webkitCurrentFullScreenElement != null
    || document.mozFullScreenElement != null
    || document.msFullscreenElement != null;
}

export function addFullscreenEventHandler(handler: (ev: Event) => void): void {
  if (document.onfullscreenchange !== undefined) {
    document.addEventListener('fullscreenchange', handler);
    return;
  }

  if (document.onwebkitfullscreenchange !== undefined) {
    document.addEventListener('webkitfullscreenchange', handler);
    return;
  }

  if (document.onmozfullscreenchange !== undefined) {
    document.addEventListener('mozfullscreenchange', handler);
    return;
  }

  if (document.onmsfullscreenchange !== undefined) {
    document.addEventListener('MSFullscreenChange', handler);
    return;
  }
}

export function removeFullscreenEventHandler(handler: (ev: Event) => void): void {
  document.removeEventListener('webkitfullscreenchange', handler);
  document.removeEventListener('mozfullscreenchange', handler);
  document.removeEventListener('MSFullscreenChange', handler);
  document.removeEventListener('fullscreenchange', handler);
}
